/**
 * Converts text to lowercase and capitalizes the first letter.
 * @param {string} text - The text to be converted.
 * @returns {string} - The converted text.
 */
export function capitalizeFirstLetter(text) {
    if (!text) return '';
    text = text.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
}